import {MouseEvent, useState} from 'react';
import AurButton from '../../../common/aur-button/AurButton';
import AurMenu, {AurMenuItem} from '../../../common/aur-menu/AurMenu';
import AurIcon, {IconNames, IconColors} from '../../../common/aur-icon/AurIcon';
import {Link} from 'react-router-dom';

const Menu: React.FC = () => {
  const onButtonClick = (event: MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
    setShowMenu(true);
  };

  const onMenuClose = () => {
    setShowMenu(false);
  };

  const [showMenu, setShowMenu] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const menuItems: AurMenuItem[] = [
    {
      label: 'Departments',
      onClick: () => {
        alert('Departments');
      },
      tooltip: 'Departments tooltip',
    },
    {
      label: 'Project Groups',
      onClick: () => {
        alert('Project Groups');
      },
      tooltip: 'Project Groups tooltip',
    },
    {
      label: 'Projects',
      onClick: () => {
        alert('Projects');
      },
    },
    {
      label: 'Permissions',
      onClick: () => {
        alert('Permissions');
      },
    },
  ];

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Menu</h1>
        <div>Menus display a list of choices in a dropdown area.</div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurButton
            type="exit"
            label={'Example Menu Button'}
            title={'Menu'}
            size="Medium"
            onClick={onButtonClick}
            children={
              <AurIcon
                icon={showMenu ? IconNames.CaretDown : IconNames.CaretUp}
                color={IconColors.Custom}
              />
            }
          />
          <div onClick={onButtonClick}>
            A menu can be attached to anything with an onClick, like this div.
          </div>
        </div>
        <AurMenu
          shouldShow={showMenu}
          onClose={onMenuClose}
          menuItems={menuItems}
          anchorElement={menuAnchor}
        />
      </div>
    </>
  );
};

export default Menu;
